import {
  companyEmployeesList,
  healthcareIndustryList,
  roleList,
  skillsList,
  useCaseList,
  workTypeList,
} from "@/redux/features/candidateProfileSlice";
import { z } from "zod";

const schema = z.object({
  idealWorkType: z.enum(workTypeList).array().optional(),
  idealRoles: z.enum(roleList).array().optional(),
  idealSubindustries: z.enum(healthcareIndustryList).array().optional(),
  idealUseCase: z.enum(useCaseList).array().optional(),
  idealCompanyHeadcount: z.enum(companyEmployeesList).array().optional(),
  topSkills: z.enum(skillsList).array().optional(),
  secondarySkills: z.enum(skillsList).array().optional(),
  additionalSkills: z.enum(skillsList).array().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateIdealEngagementFormSchema,
  type Schema as CandidateIdealEngagementFormSchema,
};
